import styled from 'styled-components'

import { theme } from '@/styles/theme'

import type { Color } from '@/components/elements/Table'

type TableData = {
  date: string
  title: string | null
  color: Color
}

const tableData: TableData[] = [
  {
    date: '6/26（土）',
    title: null,
    color: 'holiday',
  },
  { date: '6/27（日）',
    title: null,
    color: 'holiday'
  },
  {
    date: '6/28（月）',
    title: '権利付売買\u000A最終日',
    color: 'darkest'
  },
  { date: '6/29（火）',
    title: '権利落ち日',
    color: 'darkest'
  },
  {
    date: '6/30（水）',
    title: '権利確定日（配当基準日）',
    color: 'secondary',
  },
]

export const DateTable = () => {
  return (
    <Dl>
      {tableData.map(({ date, title, color }) => (
        <DescriptionGroup key={date}>
          <Dt color={color}>{date}</Dt>
          <Dd>{title}</Dd>
        </DescriptionGroup>
      ))}
    </Dl>
  )
}

const Dl = styled.dl`
  display: flex;

  @media screen and (max-width: 1047px) {
    flex-direction: column;
    border-bottom: 1px solid ${theme.colors.tableBorder};
    border-left: 1px solid ${theme.colors.tableBorder};
  }
`

const DescriptionGroup = styled.div`
  flex: 1;
  border-top: 1px solid ${theme.colors.tableBorder};
  border-right: 1px solid ${theme.colors.tableBorder};

  &:first-of-type {
    border-left: 1px solid ${theme.colors.tableBorder};

    @media screen and (max-width: 1047px) {
      border-left: none;
    }
  }

  @media screen and (max-width: 1047px) {
    display: flex;
  }
`

const Dt = styled.dt<{ color?: Color }>`
  display: grid;
  place-content: center;
  padding: 14px 14px 16px 14px;
  text-align: center;
  border-bottom: 1px solid ${theme.colors.tableBorder};
  line-height: 1.2;
  word-break: keep-all;
  background: ${({ color }) =>
    color === 'primary'
      ? theme.colors.th.primary
      : color === 'secondary'
      ? theme.colors.th.secondary
      : color === 'darkest'
      ? theme.colors.th.darkest
      : color === 'accentYellow'
      ? theme.colors.th.accentYellow
      : color === 'holiday'
      ? theme.colors.th.holiday
      : theme.colors.th.default};

  @media screen and (max-width: 1047px) {
    border-bottom: none;
    border-right: 1px solid ${theme.colors.tableBorder};
    width: 40%;
  }
`

const Dd = styled.dd`
  display: grid;
  place-content: center;
  text-align: center;
  padding: 14px 14px 16px 14px;
  line-height: 1.2;
  background: #ffffff;
  border-bottom: 1px solid ${theme.colors.tableBorder};
  word-break: keep-all;
  height: 4.3rem;
  white-space: pre-wrap;

  @media screen and (max-width: 1047px) {
    padding: 10px 12px 12px 12px;
    font-size: 13px;
    border-bottom: none;
    height: auto;
    width: 60%;
  }
`
